module.exports = __webpack_public_path__ + "static/img/medal_complete.ecaa37c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map/medal_complete.png
// module id = xOd6
// module chunks = 4